module.exports = __webpack_public_path__ + "static/media/pequeno_prazer_3.f1995a5a.jpg";